/**
 * Available validation rules
 * See https://baianat.github.io/vee-validate/guide/rules.html
 */
const availableValidations = [
  'after',
  'alpha',
  'alpha_dash',
  'alpha_num',
  'alpha_spaces',
  'before',
  'between',
  'confirmed',
  'credit_card',
  'date_between',
  'date_format',
  'decimal',
  'digits',
  'dimensions',
  'email',
  'ext',
  'image',
  'included',
  'integer',
  'ip',
  'is',
  'is_not',
  'length',
  'max',
  'max_value',
  'mimes',
  'min',
  'min_value',
  'excluded',
  'numeric',
  'regex',
  'required',
  'url',
  'unique_url',
  'empty_if', // Invalid if provided field as parameter is truthy
  'is_this_object_id',
  'is_not_this_object_id',
  'contains_uppercase',
  'contains_lowercase',
  'contains_number',
  'contains_special_character',
  'max_same_consecutive_chars',
];

export default availableValidations;
